import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { EndpointKey } from '../http/EndpointKey';
import imageUrls from '../images/imageUrls';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const RateLimitedCreationError = () => {
  const dispatch = useDispatch();

  const onClick = event => {
    event.preventDefault(); // Adding a timeout for better chances of success in case of server unreliability

    dispatch(retryEndpoint(EndpointKey.Signup, 2200));
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.RateLimitedCreationError,
    imageURL: imageUrls.clock,
    linkToHelpResources: true,
    onSentenceWithLinkClick: onClick
  });
};

export default RateLimitedCreationError;